import {action, makeObservable, observable} from 'mobx';
import {storageService} from '../services/storageService';
import {request} from '../services/HttpRequestService';
import {_login} from '../configuration/index.config';
import {has} from 'lodash';
import logger from '../services/AiLogger';
const {TOKEN_VERIFICATION_STR, ERROR_CREDENTIALS, ERROR_USER_EXIST} = _login;

export interface IUser {
    userName?: string,
    password?: string,
    osType?:string
}

export interface IErrMsg {
    userName: boolean,
    password: boolean
}

export interface IUserStore {
    onCheckUserCredentials: (user: IUser | null) => Promise<string>,
    verifyUserToken : () => Promise<boolean>,
    setUserOsType : (type) => void,
    isExpireToken: boolean,
    changeIsExpireToken : (isExpireToken:boolean) => void,
    user:IUser | null
}

class UserStore implements IUserStore {
    private authentication:any = {};
    @observable user:IUser = {}
    @observable isExpireToken = false;

    constructor() {

        makeObservable(this, {
            isExpireToken: observable,
            user: observable
        });
        request.setIsExpireToken(() => this.isExpireToken = true);
    }

    /**
     * onCheckUserCredentials - check if userName and password correct
     * @param user - user object
     */
    @action onCheckUserCredentials(user: IUser | null): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            request.getToken(user!.userName, user!.password).then(async (res) => {
                if (res.data.Active) {
                    this.user.userName = user!.userName;
                    this.user.password = user!.password;

                    storageService.saveToStorage('token', res.data.token);
                    storageService.saveToStorage('username', user!.userName);

                    await logger.sendLog(`user ${storageService.loadFromStorage('username')} connected`);
                    resolve('');
                }
                reject(ERROR_USER_EXIST);
            }).catch((error) => {
                logger.sendLog('error in get token', error, 'error');
                reject(ERROR_CREDENTIALS);
            });
        });
    }

    // eslint-disable-next-line complexity
    setAuthenticationRoutes = (authentication) => {
        for (const key in authentication) {
            if (has(authentication, key)) {
                authentication[key] && (this.authentication[key] = true);
                authentication[key] && key.split('_')[0] === 'taggingPlatform' && (this.authentication.tagging = true);
                authentication[key] && key.split('_')[0] === 'classification' && (this.authentication.classification = true);
                authentication[key] && key.split('_')[0] === 'management' && (this.authentication.management = true);
                authentication[key] && key.split('_')[0] === 'configurationPage' && (this.authentication.configurationPage = true);
                authentication[key] && key.split('_')[0] === 'faceRecognition' && (this.authentication.faceRecognition = true);
                authentication[key] && key.split('_')[0] === 'dataManagement' && (this.authentication.dataManagement = true);
                authentication[key] && key.split('_')[1] === 'video' && (this.authentication.videoTagging = true);
                authentication[key] && key.split('_')[1] === 'image' && (this.authentication.imagesTagging = true);
                authentication[key] && (key.split('_')[1] === 'accuracy' || key.split('_')[1] === 'hitl') && (this.authentication.verificationTagging = true);
            }
        }
        this.authentication.faceRecognition && Object.keys(this.authentication).every((key) => key.toLowerCase().includes('facerecognition')) ? this.setUserOsType('mobile') : this.setUserOsType('web');
    }

    /**
     * verifyUserToken - check if token is correct
     */
    @action verifyUserToken(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            request.get(storageService.loadFromStorage('token'), 'LOGIN', false, '')
                .then((res) => {
                    const authentication = res.data.credentials;

                    this.setAuthenticationRoutes(authentication);
                    this.user.osType = storageService.loadFromStorage('osType');
                    res.data.message === TOKEN_VERIFICATION_STR ? resolve(true) : reject(false);
                }).catch((e) => {
                    logger.sendLog('error in verifyUserToken', e, 'error');
                    reject(false);
                });
        });
    }
    @action getAuthenticationList = () => this.authentication;

    @action setUserName = (userName) => this.user.userName = userName
    @action changeIsExpireToken = (isExpireToken) => this.isExpireToken = isExpireToken;

    @action setUserOsType = (type) => {
        this.user.osType = type;
        storageService.saveToStorage('osType', type);
    }
}

const userStore = new UserStore();

export default userStore;

